/**
 * Используется, чтобы послать запрос. Такие же аргументы, как и у обычной функции ga
 * Пример для событий: ga('send', 'event', [eventCategory], [eventAction], [eventLabel], [eventValue], [fieldsObject]);
 */
export default function ga() {
    if (window.ga) {
        window.ga.apply(this, arguments);
    }
}